import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateCustomPerkMutation = createMutationHook(
  MembershipsCreatorApiClient.createCustomPerk,
  {
    mutationKey: ['createCustomPerk'],
  },
)
